import React, { FC } from "react";

import { CurrencyFormat, DateFormat, Status } from "@/components/atoms";
import { getInvoiceStatus } from "@/components/features/Invoices/utils/invoiceStatusMap";
import { SingleLineCell } from "@/components/molecules";
import { useNavigation } from "@/shared/hooks";
import { StyledTableCell, StyledTableRow } from "@/styles/styled";

export type InvoiceTableItemProps = {
    invoice: MyBrokerApi.Invoice;
};

const InvoiceTableItem: FC<InvoiceTableItemProps> = ({ invoice }) => {
    const { navToInvoiceDetail } = useNavigation();

    return (
        <StyledTableRow onClick={() => navToInvoiceDetail(invoice)} hover data-testid={`invoice-${invoice.id}`}>
            <SingleLineCell testId="table-cell-reference" highlight>
                {invoice.reference}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-concerns" highlight>
                {invoice.branch.name}
            </SingleLineCell>
            <SingleLineCell testId="table-cell-amount" variant="main" highlight>
                <CurrencyFormat value={invoice.amount} />
            </SingleLineCell>
            <SingleLineCell testId="table-cell-date" highlight>
                <DateFormat date={invoice.date} />
            </SingleLineCell>
            <StyledTableCell data-testid="table-cell-status">
                <Status color={getInvoiceStatus(invoice.status.id).color} text={invoice.status.name} />
            </StyledTableCell>
        </StyledTableRow>
    );
};

export default InvoiceTableItem;
